import { useTheme } from '@mui/material/styles';
import { ErrorComponent } from '@tanstack/react-router'

interface ServerErrorProps {
  error: unknown;
}

export const ServerError = ({error}: ServerErrorProps) => {
    const theme = useTheme()
    return (
    <div style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'top'
    }}>
        <div style={{textAlign: 'center' }}>
            <h2 style={{color: theme.palette.primary.main }}>500 Internal Server Error.</h2>
            <ErrorComponent error={error}/>
        </div>
    </div>
    );
}